import React from 'react'
import { Card } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { AnalyticsWorldMap } from './AnalyticsWorldMap'

const RecordAccessGeographic = ({ title,accessLocations }: { title: string,accessLocations:string[] | [] }) => {
    const { formatMessage } = useIntl()// eslint-disable-next-line
    
    return (
        <div className=''>
            <Card className='w-100 p-8 px-4 bg-white' style={{ borderBottomRightRadius: '0px', borderTopRightRadius: '0px' }}>
                <h1 className='m-0 font-size-14 text-muted fw-normal'>
                    {formatMessage({ id: title })}
                </h1>
                <div>
                    <div className='bg-transparent p-md-8 rounded-2 mb-md-4'>
                        <div className='mt-md-n8' style={{ height: '300px' }}>
                            <AnalyticsWorldMap  accessLocations={accessLocations}/>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    )
}

export default RecordAccessGeographic